export default "__VITE_ASSET__CDNbSYA___"